import { render } from "./PosSalesPaymentReportPage.vue?vue&type=template&id=cbf6a9b0&scoped=true&ts=true"
import script from "./PosSalesPaymentReportPage.vue?vue&type=script&lang=ts"
export * from "./PosSalesPaymentReportPage.vue?vue&type=script&lang=ts"

import "./PosSalesPaymentReportPage.vue?vue&type=style&index=0&id=cbf6a9b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbf6a9b0"]])

export default __exports__